export const isProductEarring = (sku: string): boolean => sku.charAt(2) === 'E';
